export function getCarId({ code = '', byoCode = '', isColorChanged = false, isVariantChanged = false }) {
  if (isVariantChanged) {
    return code;
  }

  if (isColorChanged) {
    return byoCode || code;
  }

  return code;
}

export function createBasePath(basePath: string) {
  if (!basePath) {
    return '';
  }

  if (basePath.endsWith('/')) {
    return basePath.substring(0, basePath.length - 1);
  }

  return basePath;
}
